import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { X } from "react-feather";

const DeletePopup = ({ open, setOpen, confirmAction }) => {

  return (<Dialog
    open={open}
    onClose={(e) => setOpen(false)}
    fullWidth
    maxWidth="xs"
    className="NewPopUp"
  >
    <DialogTitle id="alert-dialog-title">
      {"Delete Item?"}
      <button onClick={(e) => setOpen(false)}><X /></button>
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        <div className="ModalFormGroup">
          <label className="PopupBodyText">Are you sure to delete this item? You can't undo this action.</label>
        </div>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button className="CancelPopupBU" onClick={(e) => setOpen(false)}>Cancel</Button>
      <Button className="SubmitPopupBU" onClick={(e) => { setOpen(false); confirmAction(); }}>Confirm</Button>
    </DialogActions>
  </Dialog>);
};

export default DeletePopup;